<template>
	<div></div>
</template>

<script setup>
import { h, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useMessage, NAlert } from 'naive-ui'

const store = useStore()
const message = useMessage()

// Global message tracking - stored on window so it persists across component instances
if (!window.alertMessages) {
	window.alertMessages = new Map() // Map of id -> messageInstance
}
if (!window.alertTimestamps) {
	window.alertTimestamps = new Map() // Map of id -> timestamp when created
}

const renderMessage = (props) => {
	const { type } = props
	return h(
		NAlert,
		{
			'k-data-id': 'alertPop-container',
			closable: props.closable,
			onClose: props.onClose,
			type: type === 'loading' ? 'default' : type,
			title: props.title,
			style: {
				boxShadow: 'var(--n-box-shadow)',
				maxWidth: 'calc(100vw - 32px)',
				width: '480px'
			}
		},
		{
			default: () => props.content
		}
	)
}

onMounted(() => {
	store.watch(
		(state) => state.alert,
		(newAlert) => {
			if (newAlert) {
				showMessage(newAlert)
			}
		},
		{ immediate: true }
	)
})

function showMessage(alert) {
	const { type, message: alertMessage, duration, id, destroyId } = alert

	// If destroyId is specified, check if we can destroy that message
	if (destroyId && window.alertMessages.has(destroyId)) {
		const messageTimestamp = window.alertTimestamps.get(destroyId) || 0
		const timeSinceCreated = Date.now() - messageTimestamp

		// Special handling for upload-progress messages - enforce 1 second minimum
		if (destroyId === 'upload-progress' && timeSinceCreated < 1000) {
			return // Don't create new message or destroy existing one
		}

		window.alertMessages.get(destroyId).destroy()
		window.alertMessages.delete(destroyId)
		window.alertTimestamps.delete(destroyId)
	}

	// Create new message
	const messageInstance = message[type](alertMessage, {
		render: renderMessage,
		closable: true,
		duration: duration || 3000,
		title: type.charAt(0).toUpperCase() + type.slice(1) // Capitalize the type for the title
	})

	// Store message instance with ID if provided
	if (id) {
		window.alertMessages.set(id, messageInstance)
		window.alertTimestamps.set(id, Date.now())
	}

	// Automatically hide the alert in Vuex store
	store.dispatch('hideAlert')
}
</script>
